/**
 * @generated SignedSource<<0fbc8874a8d72fc8da7f7c5b33f87bf6>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type row_nativeIssueTable_RowWithSiblingCreate_issue$data = {
  readonly id: string;
  readonly " $fragmentSpreads": FragmentRefs<"row_nativeIssueTable_RowInner_issue">;
  readonly " $fragmentType": "row_nativeIssueTable_RowWithSiblingCreate_issue";
};
export type row_nativeIssueTable_RowWithSiblingCreate_issue$key = {
  readonly " $data"?: row_nativeIssueTable_RowWithSiblingCreate_issue$data;
  readonly " $fragmentSpreads": FragmentRefs<"row_nativeIssueTable_RowWithSiblingCreate_issue">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "isDensityFull"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "isInlineEditingEnabled"
    }
  ],
  "kind": "Fragment",
  "name": "row_nativeIssueTable_RowWithSiblingCreate_issue",
  "selections": [
    {
      "args": [
        {
          "kind": "Variable",
          "name": "isDensityFull",
          "variableName": "isDensityFull"
        },
        {
          "kind": "Variable",
          "name": "isInlineEditingEnabled",
          "variableName": "isInlineEditingEnabled"
        }
      ],
      "kind": "FragmentSpread",
      "name": "row_nativeIssueTable_RowInner_issue"
    },
    {
      "kind": "ScalarField",
      "name": "id"
    }
  ],
  "type": "JiraIssue"
};

(node as any).hash = "80e84f763af11ce539957e87daecd37c";

export default node;
